<template>
  <div>
    <van-form ref="form" :validate-first="true" :show-error-message="true">
      <van-field
        v-model="purchaseDate"
        name="采购日期"
        label="采购日期"
        placeholder="点击选择日期"
        @click=" purchaseDayShow = true"
        :rules="[{ required: true, message: '请选择采购日期' }]"
      />
      <van-field
        v-model="purchaseAmount"
        name="purchaseAmount"
        label="采购金额"
        placeholder="采购金额"
        :rules="[{ validator:purchaseAmountValidator, message: '请输人有效的采购金额' }]"
      />
      <van-field name="purchaseCertificate" label="凭证" :rules="[{ required: true, message: '采购凭证不可以为空'  }]">
        <template #input>
          <image-uploader v-model="purchaseCertificate"  prefix="platform/supplier"/>
        </template>
      </van-field>
      <van-field
        v-model="remark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="50"
        placeholder="请输入备注"
        show-word-limit
      />
      <div style="margin: 16px;">
        <van-button round block type="info"  @click="handleSubmit">保存</van-button>
      </div>
    </van-form>
    <van-calendar v-model="purchaseDayShow" :min-date="minDate" :show-confirm="false" @confirm="onPurchaseDateConfirm"  :style="{ height: '500px' }"/>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'PurchaseDetail',
  created () {
    const id = this.$route.params && this.$route.params.supplierId
    if (id) {
      this.supplierId = id
    }
  },
  data () {
    const that = this
    return {
      supplierId: null,
      purchaseDate: '',
      purchaseAmount: 0.0,
      purchaseCertificate: '',
      remark: '',
      purchaseDayShow: false,
      minDate: new Date(that.$moment(new Date()).subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    }
  },
  computed: {

  },
  methods: {
    onPurchaseDateConfirm (date) {
      this.purchaseDayShow = false
      this.purchaseDate = this.$moment(date).format('YYYY-MM-DD')
    },
    purchaseAmountValidator (val) {
      if (val == null) {
        return false
      }
      var reg = /^\d+(?=\.{0,1}\d+$|$)/
      if (reg.test(val) && val > 0) {
        return true
      }
      return false
    },
    handleSubmit () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        const formData = {
          supplierId: this.supplierId,
          purchaseAmount: this.purchaseAmount,
          purchaseDate: this.purchaseDate,
          purchaseCertificate: this.purchaseCertificate,
          remark: this.remark
        }
        this.$api.shop.addSupplierPurchaseRecrod(formData).then((res) => {
          if (res.success) {
            Toast.success(res.message)
            this.$router.go(-1)
          } else {
            Toast.fail(res.message)
          }
        })
      }).catch((ex) => {
        // Toast.fail(ex[0].message)
      })
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.supplierId = this.supplierId
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
  .warn {
    color: #ed8b08
  }
</style>
